<template>
  <Loader v-if="loader" />
  <OverlayPanel ref="op">
    <div class="w-50rem">
      <div v-if="items_locked != null">
        <DataTable :value="items_locked" tableStyle="min-width: 50rem">
          <template #header>Sospensioni bloccate</template>
          <Column field="code" header="Fornitura"></Column>
          <Column field="agente" header="Agenzia"></Column>
          <Column field="agenteFirmatario" header="Agente firmatario"></Column>
          <Column field="cliente" header="Cliente"></Column>
        </DataTable>        
      </div>
      <div v-else class="flex justify-content-center">
        <ProgressSpinner style="width:50px;height:50px" strokeWidth="8" fill="#EEEEEE" animationDuration=".5s"/>
      </div>
    </div>
  </OverlayPanel>
  <div class="flex flex-wrap">
    <div class="flex flex-column m-3 col-12">
      <div class="flex align-items-center">
        <Button class="mr-3" icon="pi pi-info" v-tooltip="`Forniture non sospendibili`" @click="toggle"/>
        <label>Blocca/sblocca sospensioni</label>
      </div>
      <InputText class="mt-2 w-full h-10rem" v-model="items_exclusion" @input="(val) => (items_exclusion = items_exclusion.toUpperCase())" placeholder="Inserisci forniture divise esclusivamente dalla virgola"/>
    </div>
    <div class="flex flex-column ml-3 col-12">
      <Button v-if="items_exclusion" icon="pi pi-send" v-tooltip="`Rendi sospendibile/non sospendibile pdp`" @click="changeStatusSospendibilePP"/>
    </div>
  </div>
  <div class="flex justify-content-between h-5rem">
    <div class="w-10rem">
      <Button v-if="selected_pp_da_sospendere.length" class="p-button-raised p-button-warning m-1" label="Da sospendere" @click="daSospendere"/>
    </div>
    <div class="flex justify-content-end align-items-center">
      <label>Tutti</label>
      <InputSwitch v-model="view_point" class="m-2" :style="{ marginRight: '5px' }" @update:modelValue="getListSolleciti"/>
      <label>Solo Point</label>
    </div>
  </div>
  <TabView class="no-underline-tabview" @update:activeIndex="updateActiveIndex">
    <TabPanel v-for="(tab, type_group) in pp_da_sospendere" :key="type_group" :header="type_group.toUpperCase()">
      <div class="p-3">
        <Accordion multiple>
          <AccordionTab v-for="(solleciti, name_type_group) in tab" :key="name_type_group" :header="name_type_group">
            <div class="p-3 shadow-2 border-round">
              <h5>{{ solleciti.length }} fatture scadute</h5>

              <DataTable :value="solleciti" sortField="data_invio" :sortOrder="-1" dataKey="id" scrollable scrollDirection="horizontal" class="w-full mt-3 custom-datatable">
                <Column style="width: 50px">
                  <template #body="{ data }">
                    <div class="flex flex-column">
                      <Checkbox
                        v-model="data.in_sospensione"
                        :binary="true"
                        v-if="data.sospendibile"
                        @update:modelValue="setSelectedPPdaSospendere(data)"
                      />
                      <small v-if="data.no_sospendibile" class="p-error mt-1">
                        {{ data.no_sospendibile }}
                      </small>
                    </div>
                  </template>
                </Column>

                <Column
                  v-for="col of columns_sospensioni"
                  :key="col.field"
                  :field="col.field"
                  :header="col.header"
                  :style="{ minWidth: col.minWidth || '120px' }"
                >
                  <template #body="{ data }">
                    <div class="w-full" v-if="data[col.field] != null">
                      <div v-if="col.type === 'link'" class="flex flex-column">
                        <Button
                          class="p-button-link"
                          :label="data[col.field]"
                          @click="goTo($event, data, col.field)"
                        />
                        <small
                          v-if="col.field === 'code' && data.stato === 3"
                          class="p-error"
                        >
                          Cessata
                        </small>
                      </div>

                      <div
                        v-else-if="col.type === 'price'"
                        class="flex justify-content-center"
                      >
                        € {{ data[col.field].toFixed(2) }}
                      </div>

                      <div
                        v-else-if="col.type === 'data'"
                        class="flex flex-column"
                      >
                        {{
                          data[col.field]
                            ? moment(data[col.field]).format("DD/MM/Y") +
                              (col.field === "data_invio"
                                ? " " +
                                  moment(data[col.field]).format("H:mm:ss")
                                : "")
                            : data[col.field]
                        }}
                        <small
                          v-if="
                            col.field === 'data_invio' &&
                            data.type_sollecito === 2
                          "
                          class="p-error"
                        >
                          Sollecito da Storno Rid
                        </small>
                      </div>

                      <div v-else>
                        {{ data[col.field] }}
                      </div>
                    </div>
                  </template>
                </Column>
              </DataTable>
            </div>
          </AccordionTab>
        </Accordion>
      </div>
    </TabPanel>
  </TabView>
</template>

<script>
import Service from "@/services/ask-management/preavvisi-fatture-clienti-service";
import { ref, onMounted, getCurrentInstance } from "vue";
import Loader from "@/components/Loader.vue";
import { useToast } from "primevue/usetoast";
import moment from "moment";
import { isArray } from "underscore";

export default {
  components: {
    Loader,
  },
  setup() {
    const loader = ref(false);

    const toast = useToast();
    const self = getCurrentInstance();
    self.$eventBus = self.appContext.config.globalProperties.$eventBus;
    self.$http = self.appContext.config.globalProperties.$http;
    const service = new Service(self.$http, self.$eventBus);
    const pp_da_sospendere = ref([]);
    const selected_pp_da_sospendere = ref([]);
    const columns_sospensioni = ref([
      {
        field: "numero",
        header: "Numero Fattura",
        type: "link",
        minWidth: "120px",
      },
      {
        field: "nomeAgenteFirmatario",
        header: "Agente Firmatario",
        minWidth: "150px",
      },
      {
        field: "nomeRappresentante",
        header: "Rappresentante",
        type: "link",
        minWidth: "150px",
      },
      { field: "cliente", header: "Cliente", type: "link", minWidth: "150px" },
      { field: "code", header: "Fornitura", type: "link", minWidth: "200px" },
      {
        field: "data_fine",
        header: "Data fine",
        type: "data",
        minWidth: "150px",
      },
      {
        field: "data_invio",
        header: "Data invio sollecito",
        type: "data",
        minWidth: "180px",
      },
      { field: "email", header: "Email", minWidth: "200px" },
      {
        field: "totale_fattura",
        header: "Totale Fattura",
        type: "price",
        minWidth: "150px",
      },
      {
        field: "totale_pagato",
        header: "Totale Pagato",
        type: "price",
        minWidth: "150px",
      },
      { field: "saldo", header: "Saldo", type: "price", minWidth: "150px" },
      { field: "contabili", header: "Contabili", minWidth: "120px" },
      { field: "dilazioni", header: "Dilazioni", minWidth: "120px" },
      {
        field: "saldo_cliente",
        header: "Saldo Cliente",
        type: "price",
        minWidth: "150px",
      },
      {
        field: "saldo_fornitura",
        header: "Saldo Fornitura",
        type: "price",
        minWidth: "150px",
      },
    ]);
    const view_point = ref(true);

    const items_exclusion = ref()
    const items_locked = ref()
    const op = ref();
    const toggle = async (event) => {
      op.value.toggle(event);      
      if(!items_locked.value){
        await service.getItemsLocked()
        .then((res)=>{        
          items_locked.value = res.items
          if (!items_locked.value.length) {
            op.value.toggle({})
          }
        })
      }
    }

    onMounted(() => {
      getListSolleciti();
    });

    const changeStatusSospendibilePP = () => {
      loader.value = true;
      let fd = new FormData()
      fd.append('items', JSON.stringify(items_exclusion.value))
        service.changeStatusSospendibilePP(fd)
        .then((res)=>{
          let severity = !res.items.success ? 'danger' : 'success'
          let detail = res.items.msg
          let toast1 = true

          if (res.items.success) {
            let items = res.items.items
            if (items['reject'].length) {
              let detail2 = []
              items['reject'].forEach(item => {
                detail2.push(item['pp']+" => "+item['error'])
              })
              toast.add({severity:'warn', detail:detail2.join('\n')})
            }
            if (items['processed'].length) {
              detail = []
              items['processed'].forEach(item => {
                detail.push(item['pp']+" => "+item['error'])
              })
            }else{
              toast1 = false
            }
          }
          if (toast1) {
            toast.add({severity:severity, detail: isArray(detail) ? detail.join('\n') : detail})
          }
          getListSolleciti()
        })
        .finally(() => {
          loader.value = false;
        });
    }
    const getListSolleciti = () => {
      loader.value = true;

      pp_da_sospendere.value = [];
      selected_pp_da_sospendere.value = [];
      items_locked.value = null
      loader.value = true;

      service.getListSolleciti(view_point.value)
        .then((res) => {
          pp_da_sospendere.value = res.items;
          Object.keys(pp_da_sospendere.value).forEach((type_group) => {
            Object.keys(pp_da_sospendere.value[type_group]).forEach(
              (solleciti) => {
                pp_da_sospendere.value[type_group][solleciti].forEach(
                  (sollecito) => {
                    sollecito.in_sospensione = Boolean(
                      sollecito.in_sospensione
                    );
                  }
                );
              }
            );
          });
        })
        .finally(() => {
          loader.value = false;
        });
    };

    const daSospendere = () => {
      let da_sospendere = selected_pp_da_sospendere.value.filter((pp) => pp.stato != 3);
      if (da_sospendere.length) {
        loader.value = true;
        service.createMultiPreSuspensionOrReactivation(da_sospendere, "", "sospensioni")
        .then((res) => {
          let severity = res.result.success ? "success" : "danger";
          let summary = res.result.success ? "Successo" : "Attenzione";
          let detail = res.result.msg;

          toast.add({severity: severity, summary: summary, detail: detail, life: 10000});
          getListSolleciti();
        })
        .finally(() => {
          loader.value = false;
        });
      } else {
        selected_pp_da_sospendere.value = [];
        toast.add({
          severity: "warn",
          summary: "",
          detail:
            "Le sospensioni selezionate corrispondono a forniture cessate",
          life: 10000,
        });
      }
    };

    const setSelectedPPdaSospendere = (data) => {
      let index = selected_pp_da_sospendere.value.findIndex(
        (pp) => pp.id == data.id
      );
      if (index == -1) {
        selected_pp_da_sospendere.value.push(data);
      } else {
        selected_pp_da_sospendere.value.splice(index, 1);
      }
    };

    const updateActiveIndex = (evt) => {
      selected_pp_da_sospendere.value = [];
      Object.keys(pp_da_sospendere.value).forEach((type_group) => {
        Object.keys(pp_da_sospendere.value[type_group]).forEach((solleciti) => {
          pp_da_sospendere.value[type_group][solleciti].forEach((sollecito) => {
            sollecito.in_sospensione = false;
          });
        });
      });
      let id_col_agente_master = columns_sospensioni.value.findIndex(
        (col) => col.field == "nomeAgente"
      );
      if (evt == 0) {
        if (id_col_agente_master != -1) {
          columns_sospensioni.value.splice(id_col_agente_master, 1);
        }
      } else {
        if (id_col_agente_master == -1) {
          columns_sospensioni.value.splice(1, 0, {
            field: "nomeAgente",
            header: "Agente",
          });
        }
      }
    };

    const goTo = (evt, data, type_path) => {
      let path;
      let type_data;
      switch (type_path) {
        case "cliente":
          path = `clienti`;
          type_data = `id_${type_path}`;
          break;
        case "numero":
          path = `clienti/fatture`;
          type_data = type_path;
          break;
        case "nomeRappresentante":
          path = `rappresentanti`;
          type_data = "idRapp";
          break;
        case "nomeAgente":
          path = `agenti`;
          type_data = "id_agente";
          break;

        default:
          path = `${data.type_fornitura}s`;
          type_data = `id_${data.type_fornitura}`;
          break;
      }
      window.open(`/ask/${path}/${data[type_data]}/dettagli`, "_blank");
    };

    return {
      pp_da_sospendere,
      loader,
      getListSolleciti,
      selected_pp_da_sospendere,
      daSospendere,
      columns_sospensioni,
      view_point,
      moment,
      setSelectedPPdaSospendere,
      updateActiveIndex,
      goTo,
      changeStatusSospendibilePP,
      items_exclusion,
      toggle,
      op,
      items_locked,
    };
  },
};
</script>

<style scoped>
.p-button-color-white {
  color: white !important;
  background: transparent !important;
  border: transparent !important;
}

.shadow-2 {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.border-round {
  border-radius: 8px;
}

.no-underline-tabview .p-tabview-nav::before {
  display: none;
}

.no-underline-tabview .p-tabview-nav-container::before {
  display: none;
}

.text-right {
  text-align: right;
}

.text-center {
  text-align: center;
}

.accordion-container {
  width: 120%;
  padding: 0;
}

.table-container {
  overflow-x: auto;
}

.accordion-content {
  padding: 1rem;
}

.shadow-2 {
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
}

.border-round {
  border-radius: 8px;
}

.table-container {
  overflow-x: auto;
}
</style>
